module.exports = __webpack_public_path__ + "assets/img/W-5-F.7f136653.png";